<div class="header">
  <h1>Aumye Incident Management</h1>
</div>
<div class="container">
  <div class="form-section">
    <div class="select-container">
      <mat-form-field appearance="outline">
        <mat-label>Select Option</mat-label>
        <mat-select
          [value]="selectedOption"
          (selectionChange)="onSelectionChange($event)"
        >
          <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="content-container">
      <mat-divider></mat-divider>
      <section *ngIf="selectedOption === 'incident'">
        <div
          [ngClass]="{
            'incident-gate-entry-header':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,

            'incident-gate-entry-header-mobile': screenSize == ScreenType.Mobile
          }"
        >
          New Incident &#64;{{ timeNow | date : "medium" }}
        </div>
        <mat-divider></mat-divider>
        <div class="incident-gate-entry-form">
          <form [formGroup]="incidentManualEvent">
            <mat-grid-list
              [cols]="screenSize == ScreenType.Mobile ? 1 : 3"
              rowHeight="80px"
              gutterSize="10px"
            >
              <mat-grid-tile rowspan="4">
                <div class="upload-manual-event-evidence">
                  <div class="event-evidence-image-container">
                    <img
                      *ngIf="!showWebcam"
                      [src]="eventEvidence"
                      alt="Upload evidence"
                    />
                    <div *ngIf="showWebcam">
                      <webcam
                        [trigger]="invokeObservable"
                        [switchCamera]="nextWebcamObservable"
                        (imageCapture)="captureImg($event)"
                        [width]="screenSize == ScreenType.Mobile ? 280 : 320"
                        [height]="screenSize == ScreenType.Mobile ? 380 : 320"
                      ></webcam>
                    </div>
                  </div>
                  <div class="upload-evidence-button">
                    <div *ngIf="!isCamera">
                      <label for="evidencepic" class="upload-button-label"
                        >Upload</label
                      >
                      <input
                        style="display: none"
                        id="evidencepic"
                        (change)="onUploadEvidence($event)"
                        type="file"
                        name=""
                        accept="image/*"
                      />
                    </div>
                    <div *ngIf="isCamera">
                      <mat-form-field
                        style="width: 150px; padding: 10px 5px 0 0"
                        subscriptSizing="dynamic"
                        appearance="outline"
                      >
                        <mat-label>Camera</mat-label>
                        <mat-select
                          [value]="deviceSelected"
                          (valueChange)="onDeviceSelectChange($event)"
                        >
                          <mat-option
                            *ngFor="let device of availableDevices"
                            [value]="device.deviceId"
                            >{{ device.label }}</mat-option
                          >
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="!isCamera" style="height: 48px">
                      <button (click)="onClickOpenCamera()" mat-raised-button>
                        {{ "Click" }}
                      </button>
                    </div>
                    <div *ngIf="isCamera" style="height: 48px">
                      <button (click)="getSnapshot()" mat-raised-button>
                        {{
                          showWebcam || !isDeviceSelected
                            ? "Capture"
                            : "ReCapture"
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </mat-grid-tile>
              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Incident Type</mat-label>
                  <mat-select formControlName="incidentType">
                    <mat-option value="manual">Manual </mat-option>
                  </mat-select>
                </mat-form-field></mat-grid-tile
              >
              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Incident Name</mat-label>
                  <mat-select formControlName="incidentName">
                    <mat-option
                      *ngFor="let incidentType of incidentTypes"
                      [value]="incidentType"
                      >{{ incidentType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field></mat-grid-tile
              >
              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Incident Description</mat-label>
                  <input
                    matInput
                    formControlName="incidentDescription"
                  /> </mat-form-field
              ></mat-grid-tile>
              <mat-grid-tile *ngIf="viewIncident != null"
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Location Reference</mat-label>
                  <input
                    readonly
                    matInput
                    [value]="viewIncident"
                  /> </mat-form-field
              ></mat-grid-tile>
              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="incidentStatus">
                    <mat-option value="0">Open</mat-option>
                  </mat-select>
                </mat-form-field></mat-grid-tile
              >
              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Priority</mat-label>
                  <mat-select formControlName="incidentCriticality">
                    <mat-option value="High">High</mat-option>
                    <mat-option value="Medium">Medium</mat-option>
                    <mat-option value="Low">Low</mat-option>
                  </mat-select>
                </mat-form-field></mat-grid-tile
              >
              <mat-grid-tile>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Select Assign*</mat-label>
                  <input
                    matInput
                    [formControl]="selectedUsersControl"
                    [matAutocomplete]="autoAdmin"
                  />
                  <mat-icon
                    style="background-color: transparent; color: #e93578"
                    matSuffix
                    (click)="clearInputField()"
                    >clear</mat-icon
                  >
                  <mat-autocomplete
                    (optionSelected)="addUser($event)"
                    #autoAdmin="matAutocomplete"
                  >
                    <mat-option
                      *ngFor="let host of filteredAssignee"
                      [value]="host.firstname + ' ' + host.lastname"
                    >
                      <img
                        class="visitor-img"
                        [src]="host.profilePicture"
                        height="30"
                        width="36"
                      />
                      <span> {{ host.firstname + " " + host.lastname }}</span>
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile *ngIf="usersTemp.length > 0">
                <div class="selected-users">
                  <mat-chip
                    *ngFor="let user of usersTemp"
                    [removable]="true"
                    (removed)="removeUser(user)"
                  >
                    {{ user }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </div>
              </mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Tag Name</mat-label>
                  <input
                    matInput
                    formControlName="eventOwnerName"
                    [matAutocomplete]="autoOwner"
                  />
                  <mat-autocomplete
                    (optionSelected)="ownerSelect($event.option.value)"
                    #autoOwner="matAutocomplete"
                    autoActiveFirstOption
                  >
                    <mat-option
                      *ngFor="let owner of filteredUsers | async"
                      [value]="owner"
                    >
                      {{ owner.fullname | titlecase }} -
                      <span style="font-size: 15px; font-style: italic">{{
                        owner.type == 0
                          ? "User"
                          : owner.type == 1
                          ? "Employee"
                          : owner.type == 3
                          ? "New Tag"
                          : "Visitor"
                      }}</span>
                      -
                      <span style="font-size: 12px; font-style: italic">{{
                        getCustomPhoneNumber(owner.mobile)
                      }}</span>
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </mat-grid-tile>

              <mat-grid-tile
                ><mat-form-field subscriptSizing="dynamic" appearance="outline">
                  <mat-label>Tag Email </mat-label>
                  <input
                    matInput
                    formControlName="eventOwnerEmail"
                  /> </mat-form-field
              ></mat-grid-tile>
              <mat-grid-tile>
                <mat-form-field
                  class="custom-padding-fix"
                  appearance="outline"
                  subscriptSizing="dynamic"
                >
                  <ngx-mat-intl-tel-input
                    #phoneInput
                    [enablePlaceholder]="true"
                    [required]="false"
                    [preferredCountries]="['in']"
                    [enableSearch]="true"
                    name="phone"
                    formControlName="eventOwnerPhone"
                    [inputPlaceholder]="'Tag Number'"
                    [label]="'Owner Number'"
                    [maxlength]="15"
                    [disabled]="isOwnerSelected"
                  ></ngx-mat-intl-tel-input>
                  <mat-error
                    *ngIf="incidentManualEvent.controls['eventOwnerPhone']?.errors?.['validatePhoneNumber']
                      &&
                      false"
                    ><i>Enter valid number</i>
                  </mat-error>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile>
                <div class="notify-host-button">
                  <button (click)="onClickOpenMap()" mat-raised-button>
                    Select Location
                  </button>
                </div>
              </mat-grid-tile>
              <mat-grid-tile>
                <div class="notify-host-button">
                  <button
                    [disabled]="incidentManualEvent.invalid"
                    (click)="createManualEvent()"
                    mat-raised-button
                  >
                    Notify
                  </button>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
          </form>
        </div>
      </section>
      <section *ngIf="selectedOption === 'complaint'">
        <div
          [ngClass]="{
            'incident-gate-entry-header':
              screenSize == ScreenType.Desktop ||
              screenSize == ScreenType.Tablet,

            'incident-gate-entry-header-mobile': screenSize == ScreenType.Mobile
          }"
        >
          Request Form
        </div>
        <mat-divider></mat-divider>
        <div class="tickets-dialog-options">
          <form [formGroup]="lodgeComplaintTicket">
            <mat-form-field appearance="outline">
              <mat-label>Subject </mat-label>
              <mat-select
                (selectionChange)="onChangeComplainType($event)"
                formControlName="complainSubject"
              >
                <mat-option value="Service Request">
                  Service Request</mat-option
                >
                <mat-option value="Complain"> Complain </mat-option>
                <mat-option value="Claim"> Claim </mat-option>
              </mat-select>
            </mat-form-field>
            <br />
            <mat-form-field appearance="outline">
              <mat-label>Select Assign*</mat-label>
              <input
                matInput
                [formControl]="selectedUsersControl"
                [matAutocomplete]="autoAdmin"
                formControlName="Assignee"
              />
              <mat-icon
                style="background-color: transparent; color: #e93578"
                matSuffix
                (click)="clearInputField()"
                >clear</mat-icon
              >
              <mat-autocomplete
                (optionSelected)="addUser($event)"
                #autoAdmin="matAutocomplete"
              >
                <mat-option
                  *ngFor="let host of filteredAssignee"
                  [value]="host.firstname + ' ' + host.lastname"
                >
                  <img
                    class="visitor-img"
                    [src]="host.profilePicture"
                    height="30"
                    width="36"
                  />
                  <span> {{ host.firstname + " " + host.lastname }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <br />
            <div class="selected-users" *ngIf="usersTemp.length > 0">
              <mat-chip
                *ngFor="let user of usersTemp"
                [removable]="true"
                (removed)="removeUser(user)"
              >
                {{ user }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <br />
            </div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{
                  lodgeComplaintTicket.controls.complainSubject.value ===
                  "Claim"
                    ? "Claim Description"
                    : "Description"
                }}
              </mat-label>
              <textarea
                formControlName="complainDescription"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="2"
                matInput
              ></textarea>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              *ngIf="
                lodgeComplaintTicket.controls.complainSubject.value === 'Claim'
              "
            >
              <mat-label>Claim Amount</mat-label>
              <input
                formControlName="claimAmount"
                (keypress)="inputValidator($event)"
                matInput
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              *ngIf="
                lodgeComplaintTicket.controls.complainSubject.value === 'Claim'
              "
            >
              <mat-label>Claim Type</mat-label>
              <mat-select formControlName="claimType">
                <mat-option value="Party">Damage</mat-option>
                <mat-option value="Official">Accidental</mat-option>
                <mat-option value="Social">Medical</mat-option>
                <mat-option value="Meeting">Content</mat-option>
                <mat-option value="Gathering">Vehicle</mat-option>
                <mat-option value="Other">Other</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Priority</mat-label>
              <mat-select formControlName="incidentCriticality">
                <mat-option value="High">High</mat-option>
                <mat-option value="Medium">Medium</mat-option>
                <mat-option value="Low">Low</mat-option>
              </mat-select>
            </mat-form-field>
            <div
              class="attachment-wrapper"
              *ngIf="
                lodgeComplaintTicket.controls.complainSubject.value !== 'Leave'
              "
            >
              <div class="attachment-uploaded-content">
                <ng-container
                  *ngFor="let file of selectedAttachments; let i = index"
                >
                  <div class="attachment-name">
                    <p>
                      <b
                        >{{ i + 1 + "." }} &nbsp;{{
                          file.name | truncateCase : 12
                        }}</b
                      >
                    </p>
                  </div>
                </ng-container>
                <ng-container *ngIf="selectedAttachments.length == 0">
                  <div class="attachment-name" style="justify-content: center">
                    <p>
                      <b>{{ "Upload" }}</b>
                    </p>
                  </div>
                </ng-container>
              </div>
              <button
                type="button"
                (click)="fileInput1.click()"
                mat-icon-button
              >
                <mat-icon>{{
                  selectedAttachments.length > 0 ? "add" : "attach_file"
                }}</mat-icon>
              </button>
              <input
                type="file"
                #fileInput1
                style="display: none"
                accept=".pdf, .jpeg, .png"
                multiple
                (change)="onAttachmentSelected($event)"
              />
            </div>
            <div
              class="checkbox-container"
              *ngIf="
                lodgeComplaintTicket.controls.complainSubject.value != null &&
                lodgeComplaintTicket.controls.complainSubject.value !==
                  'Claim' &&
                lodgeComplaintTicket.controls.complainSubject.value !==
                  'Complain'
              "
            >
              <mat-checkbox formControlName="isRecurring"
                >Make Recurring</mat-checkbox
              >
            </div>
            <div *ngIf="lodgeComplaintTicket.controls.isRecurring.value">
              <br />

              <mat-form-field appearance="outline">
                <mat-label>Select Frequency</mat-label>
                <mat-select
                  formControlName="selectedFrequency"
                  (selectionChange)="onFrequencyChange($event)"
                >
                  <!-- Everyday Option -->
                  <mat-option value="everyday">Everyday</mat-option>

                  <!-- Specific Day of the Week Option -->
                  <mat-option value="specificDay"
                    >Specific Day of the Week</mat-option
                  >

                  <!-- Specific Date of Month Option -->
                  <mat-option value="specificDate"
                    >Specific Date of Month</mat-option
                  >

                  <!-- Twice a Week Option -->
                  <mat-option value="twiceAWeek">Twice a Week</mat-option>

                  <!-- Twice a Month Option -->
                  <mat-option value="twiceAMonth">Twice a Month</mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'specificDay' ||
                  lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'twiceAWeek'
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Select Day(s)</mat-label>
                  <mat-select
                    formControlName="selectedDays"
                    [multiple]="true"
                    (selectionChange)="selectionLimit($event, 'day')"
                  >
                    <mat-option *ngFor="let day of daysOfWeek" [value]="day">{{
                      day
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                *ngIf="
                  lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'specificDate' ||
                  lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'twiceAMonth'
                "
              >
                <mat-form-field appearance="outline">
                  <mat-label>Select Date(s)</mat-label>
                  <mat-select
                    formControlName="selectedDates"
                    [multiple]="true"
                    (selectionChange)="selectionLimit($event, 'date')"
                  >
                    <mat-option
                      *ngFor="let date of datesOfMonth"
                      [value]="date"
                      >{{ date }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <br />
              <div class="selected-options" *ngIf="false">
                {{
                  lodgeComplaintTicket.controls.selectedFrequency.value | json
                }}
                <h3>Selected Frequency:</h3>
                <p
                  *ngIf="
                    lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'everyday'
                  "
                >
                  Everyday
                </p>
                <p
                  *ngIf="
                    lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'twiceAWeek'
                  "
                >
                  Twice a Week
                </p>
                <p
                  *ngIf="
                    lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'twiceAMonth'
                  "
                >
                  Twice a Month
                </p>
                <p
                  *ngIf="
                    lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'specificDay'
                  "
                >
                  Specific Days of the Week:
                  <span
                    *ngFor="
                      let day of lodgeComplaintTicket.controls.selectedDays
                        .value
                    "
                  >
                    {{ day }}
                  </span>
                </p>
                <p
                  *ngIf="
                    lodgeComplaintTicket.controls.selectedFrequency.value ===
                    'specificDate'
                  "
                >
                  Specific Dates of the Month:
                  <span
                    *ngFor="
                      let date of lodgeComplaintTicket.controls.selectedDates
                        .value
                    "
                  >
                    {{ date }}
                  </span>
                </p>
              </div>
            </div>
            <button [disabled]="lodgeComplaintTicket.invalid" mat-raised-button>
              Submit
            </button>
          </form>
        </div>
      </section>
      <!-- Conditionally display the components based on selection -->
      <!-- <app-incident ></app-incident>
        <app-complaint "></app-complaint> -->
    </div>
  </div>
</div>
